<template>
	<div class="transfer-slide">
		<common-layout>
			<div slot="header">
				<h3>轮播图设置</h3>
			</div>
			<div slot="container">
				<div class="hot-search">
					<el-button type="success" icon="el-icon-plus" @click="addNews" style="background: #623AA2; border: none;">新增</el-button>
					<el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
				</div>

				<div class="hot-table">
					<el-table ref="multipleTable" :data="tableData" style="width: 100%" :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
					 class="table" @selection-change="selectionChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column type="index" width="150" label="序号" align="center">
							<template slot-scope="scope">
								<span>{{
                  scope.$index + (paramsObj.page - 1) * paramsObj.pageSize + 1
                }}</span>
							</template>
						</el-table-column>
						<el-table-column label="图片" align="center">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper">
									<img style="height: 50px;" :src="scope.row.logoSrc[0].url" />
								</div>
							</template>
						</el-table-column>

						<el-table-column label="时间" align="center">
							<template slot-scope="scope">
								<div slot="reference" class="name-wrapper">
									<span size="medium">{{ scope.row.publishedTime }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作">
							<template slot-scope="scope">
								<el-button size="mini" type="success" @click="release(scope.row)" v-if="scope.row.publishedFlag == 0">确认发布</el-button>
								<el-button size="mini" type="warning" @click="release(scope.row)" v-else>取消发布</el-button>
								<el-button class="mini_btn" size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
								<el-button class="mini_btn" size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-pagination @current-change="handleCurrentChange" :current-page.sync="paramsObj.page" :page-size="paramsObj.pageSize" layout="total, prev, pager, next"
				 :total="total" style="text-align:left;margin:20px 0">
				</el-pagination>
			</div>
		</common-layout>
		<el-dialog :title="Title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
			<el-form :model="formData" ref="formData" :rules="rules" label-width="100px" class="demo-formData">
				<el-form-item label="图片" style="text-align:center;" prop="logo" class="img_wrap">
					<el-upload class="avatar-uploader" :action="this.uploadURL" name="file" :show-file-list="false" :file-list="logo"
						:on-success="
							(response, file, fileList) => handlePictureCardPreview(response, file, fileList, 'logo')
						"
					 :before-upload="beforeAvatarUpload">
						<img v-if="formData.logo" :src="logo[0].url" class="img_border" />
						<i v-else class="el-icon-plus avatar-uploader-icon" :class="{ is_border: !formData.logo }"></i>
						<span class="upload_btn" v-if="!formData.logo">上传图片</span>
						<span v-else class="upload_btn">更换图片</span>
						<div slot="tip" class="el-upload__tip">温馨提示：请选择1920X990像素的图片</div>
					</el-upload>
					<span class="del_img" v-show="formData.logo">
						<i class="el-icon-error" @click="deleteImg"></i>
					</span>
				</el-form-item>
				<el-form-item label="发布时间" prop="publishedTime">
					<el-date-picker v-model="formData.publishedTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
					 placeholder="请选择日期" style="text-align: left;width:100%"></el-date-picker>
				</el-form-item>
				<el-form-item label="详情地址" prop="addressDetail">
					<el-input placeholder="请输入对应新闻页面的地址" v-model="formData.addressDetail" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="是否发布" prop="publishedFlag" style="text-align:left">
					<el-switch v-model="formData.publishedFlag" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
					 inactive-text="否" :active-value="1" :inactive-value="0">
					</el-switch>
				</el-form-item>
				<el-form-item style="text-align:right;margin-top:10px">
					<el-button type="primary" @click="submitForm('formData')">提交</el-button>
					<el-button @click="closeForm('formData')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import CommonLayout from "../../../components/common-layout.vue";
	export default {
		components: {
			CommonLayout
		},
		data() {
			return {
				limit: 1,
				listUrl: `${urlConfig.devUrl}apij2/admin-api/voucher/trade-carousel/page`,
				tableData: [],
				total: 10,
				dialogFormVisible: false,
				selected: "",
				Title: "",
				logo: [],
				paramsObj: {
					page: 1, 
					pageSize: 10
				},
				formData: {
					logo: "",
					addressDetail : "",
					publishedTime: "",
					publishedFlag: 0,
				},
				operateId: 0,
				rules: {
					publishedTime: [{
						type: 'string',
						required: true,
						message: '请选择时间',
						trigger: 'change'
					}],
					logo: [{
						required: true,
						message: '请上传图片',
						trigger: 'change'
					}],
					name: [{
						type: 'string',
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}],
					addressDetail: [{
						type: 'string',
						required: true,
						message: '请输入对应新闻页面的地址',
						trigger: 'blur'
					}]
				}
			};
		},
		created() {
			this.getData();
		},
		methods: {
			getData() {
				this.http.post(this.listUrl, this.paramsObj).then(res => {
					if (res.code == 0) {
						let arr = res.data.data;
						arr.forEach(item => {
							if(item.logo) {
								item.logoSrc = JSON.parse(item.logo);
							}else{
								item.logoSrc = []
							}
						})
						this.tableData = arr;
						this.total = res.data.total;
					}
				});
			},
			//新增
			addNews() {
				this.Title = "新增";
				this.dialogFormVisible = true;
				this.formData = {
					logo: "",
					publishedTime: "",
					publishedFlag: 0,
					name: '',
					addressDetail : ""
				};
				this.logo = []
			},
			//编辑
			handleEdit(val) {
				this.operateId = val.id
				this.Title = "编辑";
				this.dialogFormVisible = true;
				// console.log(val)
				// this.formData = JSON.parse(JSON.stringify(val));
				this.getDetail(val)
			},
			getDetail(val) {
				this.http.get(`${urlConfig.devUrl}apij2/admin-api/voucher/trade-carousel/get?id=${val.id}`).then(res => {
					if (res.code == 0) {
						console.log(res.data)
						this.formData = res.data
						this.logo = res.data.logo ? JSON.parse(res.data.logo) : []
					} else {
						this.$message.error(res.status);
					}
				});
			},
			//提交
			submitForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let obj = JSON.parse(JSON.stringify(this.formData));
						obj.type = 3
						if (!obj.id) {
							this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/trade-carousel/create`, obj).then(res => {
								if (res.code == 0) {
									this.$message.success("新增成功");
									this.getData();
									this.dialogFormVisible = false;
									this.$refs[formName].resetFields();
								} else {
									this.$message.error(res.status);
								}
							});
						} else {
							this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/trade-carousel/update`, obj).then(res => {
								if (res.code == 0) {
									this.$message.success("编辑成功");
									this.getData();
									this.dialogFormVisible = false;
									this.$refs[formName].resetFields();
								} else {
									this.$message.error(res.status);
								}
							});
						}
					} else {
						return false;
					}
				});
			},
			//关闭
			closeForm(formName) {
				this.dialogFormVisible = false;
				this.$refs[formName].resetFields();
			},
			//批量删除
			deleteAll() {
				if (this.selected.length > 0) {
					this.$confirm("确定删除文件吗?", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
							center: true
						})
						.then(() => {
							let obj = {
								ids: this.selected
							}
							this.http
								.post(`${urlConfig.devUrl}apij2/admin-api/voucher/trade-carousel/deletes`, obj)
								.then(response => {
									if (response.code == 0) {
										this.$message.success("删除成功！");
										this.paramsObj.page = 1
										this.getData();
									}
								});
							this.$message({
								type: "success",
								message: "删除成功!"
							});
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消删除"
							});
						});
				} else {
					this.$message({
						type: "warning",
						message: "请选择删除的文件"
					});
				}
			},
			//删除
			handleDelete(row) {
				this.$confirm("此操作将永久删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true
					})
					.then(() => {
						this.http.delete(`${urlConfig.devUrl}apij2/admin-api/voucher/trade-carousel/delete?id=${row.id}`).then(res => {
							if (res.code == 0) {
								this.paramsObj.page = 1
								this.getData();
								this.$message({
									type: "success",
									message: "删除成功"
								});
							} else {
								this.$message({
									message: "失败！",
									type: "error"
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			},
			//选择行数
			selectionChange(sec) {
				console.log(sec)
				let ids = [];
				for (let i of sec) {
					ids.push(i.id);
				}
				console.log(ids)
				this.selected = ids;
			},
			//发布
			release(e) {
				this.$confirm(e.publishedFlag == 0 ? "确定发布吗?" : "确定取消发布吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					center: true
				})
				.then(() => {
					this.operateRelease(e)
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: e.publishedFlag == 0 ? "取消确认发布" : "取消发布"
					});
				});					
				
			},
			operateRelease(e) {
				let data = e;
				if (e.publishedFlag == 0) {
					data.publishedFlag = 1;
				} else if (e.publishedFlag == 1) {
					data.publishedFlag = 0;
				}
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/trade-carousel/update`, data).then(res => {
					if (res.code == 0) {
						if (data.publishedFlag == 1) {
							this.$message.success("发布成功");
						} else {
							this.$message.success("已取消发布");
						}
						this.getData();
					} else {
						this.$message.error(res.status);
					}
				});
			},
			//翻页
			handleCurrentChange(val) {
				this.paramsObj.page = val
				this.getData()
			},
			handlePictureCardPreview(response, file, fileList, type) {
				console.log('aaa')
				console.log('fileList', fileList)
				console.log('file', file)
				// this.formData.logo = file.data.store_result;
				if (response.code == 0) {
					let arr = []
					// if(fileList.length > 0) {
					// 	fileList.map(item => {
							arr.push({
								url: file.size ? this.imgUrl + file.response.data.store_result : file.url,
								name: file.name
							});
					// 	});
					// }
					console.log(arr[0].url)
					if(arr.length > 0) {
						this[type] = arr;
						this.formData[type] = JSON.stringify(arr);
					}else{
						this.formData[type] = '';
						this[type] = [];
					}
				}
			},
			beforeAvatarUpload(file) {
				console.log('file', file)
				return new Promise((resolve,reject) => {
					let type = false;
					if (
						file.type === "image/jpeg" ||
						file.type === "image/png" ||
						file.type === "image/jpg" ||
						file.type === "image/gif" ||
						file.type === "image/bmp"
					) {
						type = true;
					}

					const isLt2M = file.size / 1024 / 1024 < 10;
					if (!type) {
						this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
					}
					if (!isLt2M) {
						this.$message.error("上传图片大小不能超过 10MB!");
					}
					let flag = false
					//调用[限制图片尺寸]函数
					this.limitFileWH(1920, 990, file).then((res) => {
						console.log('res', res)
							flag = res
							// if(!res) {
							// 	this.logo = []
							// 	this.formData.logo = ""
							// }
							
					if (flag) {
						return resolve(true);
					} else {
						return reject(false);
					}
					})
				})

				
				// let flag = this.limitFileWH(1920, 990, file)

				// console.log('flag', flag)
				// return type && isLt2M && flag;
			},

			//限制图片尺寸
			async limitFileWH(E_width, E_height, file) {
        let _this = this;
        let imgWidth = "";
        let imgHight = "";
        const isSize = new Promise(function(resolve, reject) {
            let width = E_width;
            let height = E_height;
            let _URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = function() {
                imgWidth = img.width;
                imgHight = img.height;
                let valid = img.width == width && img.height == height;
                valid ? resolve() : reject();
            }
						console.log('_URL', _URL)
            img.src = _URL.createObjectURL(file);
        }).then(() => {
            return true;
        }, () => {
            _this.$message.warning({
            message: '上传文件的图片大小不合符标准,宽需要为' + E_width + 'px，高需要为' + E_height + 'px。当前上传图片的宽高分别为：' + imgWidth + 'px和' +
                            imgHight + 'px',
            btn: false,
						duration: 2000
        })
            return false;
        });
            return isSize
    },
			deleteImg() {
				this.$confirm("确定删除图片吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true
					})
					.then(() => {
						this.formData.logo = "";
						this.$message({
							type: "success",
							message: "删除成功!"
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			}
		}
	};
</script>
<style lang="scss">
	@include component(transfer-slide) {
		width: 100%;
		height: 100%;

		.hot-search {
			width: 100%;
			text-align: left;
			display: flex;
			justify-content: flex-start;
		}

		.img_wrap{
			margin-bottom: 50px !important;
		}
		.hot-table {
			width: 100%;
			margin-top: 10px;
			border: 1px solid #eef1f6;
		}

		/*上传图片*/
		.is_border {
			border: 1px dashed #ddd !important;
			border-radius: 5px;
			height: 154px !important;
			line-height: 154px !important;
		}

		.upload_btn {
			display: block;
			background-color: #00a1ff;
			font-weight: bold;
			color: #fff;
			padding: 2px;
			border-bottom-left-radius: 3px;
			border-bottom-right-radius: 3px;
		}

		.upload_btn:hover {
			background-color: #13ce66;
		}

		.del_img {
			position: absolute;
			top: -7px;
			left: 224px;
			color: #00a1ff;
		}

		.del_img:hover {
			cursor: pointer;
			color: #f00;
		}

		.del_img i:before {
			font-size: 20px;
		}

		.img_border {
			border-top-left-radius: 3px;
			border-top-right-radius: 3px;
			width: 243px;
			height: 154px;
			display: block;
		}

		.avatar-uploader {
			text-align: center;
			width: 243px;
		}

		/deep/ .el-upload {
			border: 1px dashed #d9d9d9 !important;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		/deep/ .el-upload:hover {
			border-color: #409eff !important;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 243px;
			height: 154px;
			line-height: 154px;
			text-align: center;
		}
	}
</style>
